import React from "react";
import { WithSearch } from "@elastic/react-search-ui";
import CustomPagination from "./CustomPagination";


/**
 * 
 * Handles the integration with react-search-ui
 * @param  
 * @returns 
 */
export default function CustomPaginationView({ pagingContainer }) {
  return (
    <WithSearch mapContextToProps={({ current, totalPages, setCurrent }) => {
      return {
        current: current || 1,
        totalPages: totalPages || 1,
        setCurrent: setCurrent,
        pagingContainer:pagingContainer // Forward the prop
      };
    }}>
      {(props) => <CustomPagination {...props} />}
    </WithSearch>
  );
}